module.exports = __webpack_public_path__ + "img/linkedin.6311797b.svg";